import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter,
  Routes,
  Route,
} from 'react-router-dom';

// CSS Imports
import './css/rsuite.css';
import './css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './css/sweetalert2.css';

// Import Home page
import HomePage from './pages/applications/HomePage';

// Import applications pages
import FormApplyPage from './pages/applications/FormApplyPage';
import FormRegisterPage from './pages/applications/FormRegisterPage';
import ResultsPage from './pages/applications/ResultsPage';

// Import scholarship pages
import ProfileHomePage from './pages/scholarship/HomePage';
import ProfileDetailPage from './pages/scholarship/DetailPage';
import ProfileEditPage from './pages/scholarship/EditPage';
import EducationPage from './pages/scholarship/EducationPage';
import ActivitiesPage from './pages/scholarship/ActivitiesPage';
import CounselingPage from './pages/scholarship/CounselingPage';
import CareerPage from './pages/scholarship/CareerPage';

// Import admin pages
import LoginPage from './pages/admin/LoginPage';
import AdminHomePage from './pages/admin/HomePage';
import DashboardPage from './pages/admin/DashboardPage';
import ApplicantPage from './pages/admin/ApplicantPage';
import ApprovedPage from './pages/admin/ApprovedPage';
import DetailPage from './pages/admin/DetailPage';
import EditPage from './pages/admin/EditPage';
import AnnouncementPage from './pages/admin/AnnouncementPage';
import EthnicPage from './pages/admin/EthnicPage';
import VillagePage from './pages/admin/VillagePage';
import SchoolsPage from './pages/admin/SchoolsPage';
import UsersPage from './pages/admin/UsersPage';
import AdministratorPage from './pages/admin/AdministratorPage';
import ReportPage from './pages/admin/ReportPage';
import UsersLoginPage from './pages/admin/UsersLoginPage';
import ActivitiesAdminPage from './pages/admin/ActivitiesPage';
import CounselingAdminPage from './pages/admin/CounselingPage';
import CommitteePage from './pages/admin/CommitteePage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <Routes>

        {/* หน้าหลัก */}
        <Route path="/" element={<HomePage />} />

        {/* User Routes */}
        <Route path="login" element={<UsersLoginPage />} />
        <Route path="form_apply" element={<FormApplyPage />} />
        <Route path="form_register" element={<FormRegisterPage />} />

        {/* Profile Routes */}
        <Route path="/profile" element={<ProfileHomePage />}>
          <Route index element={<ProfileDetailPage />} />
          <Route path="edit" element={<ProfileEditPage />} />
          <Route path="education" element={<EducationPage />} />
          <Route path="activities" element={<ActivitiesPage />} />
          <Route path="counseling" element={<CounselingPage />} />
          <Route path="career" element={<CareerPage />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin" element={<AdminHomePage />}>
          <Route index element={<DashboardPage />} /> {/* ✅ Default page when visit /admin */}
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="applicant" element={<ApplicantPage />} />
          <Route path="applicant/detail/:id" element={<DetailPage />} />
          <Route path="applicant/edit/:id" element={<EditPage />} />
          <Route path="approved" element={<ApprovedPage />} />
          <Route path="announcement" element={<AnnouncementPage />} />
          <Route path="ethnic" element={<EthnicPage />} />
          <Route path="village" element={<VillagePage />} />
          <Route path="schools" element={<SchoolsPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="administrator" element={<AdministratorPage />} />
          <Route path="report" element={<ReportPage />} />
          <Route path="activities" element={<ActivitiesAdminPage />} />
          <Route path="counseling" element={<CounselingAdminPage />} />
        </Route>

        {/* Committee Routes */}
        <Route path="committee/:id" element={<CommitteePage />} />

        {/* Results Routes */}
        <Route path="results/:year" element={<ResultsPage />} />

      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();